import React, {useEffect, useState} from 'react'
import ds from "../../controller/DataService";

export default function Resolve() {
    const [language, setLanguage] = useState('_');

    const redirect = async () => {
        let id = !!window && !!window.location && !!window.location.pathname ? window.location.pathname.substr(1) : '';
        window.location.assign((await ds.resolveLink(id)).replace("https://link.myrealfood.app/", "es.myrealfood.myrealfood://"))
    }

    const locales = {
        _: {
            title: 'Ya puedes cerrar esta pestaña',
            description: 'Si tu aplicación se ha abierto, puedes cerrar esta pestaña.',
            close: 'Cerrar pestaña'
        },
        en: {
            title: 'You Can Now Close This Tab',
            description: 'If your app has opened, you can close this tab.',
            close: 'Close Tab'
        }
    }

    useEffect(() => {
        // Get the user's language from the browser
        let userLanguage = navigator.language || navigator.userLanguage;
        const lang = userLanguage?.split("-")[0] || "_";
        if (Object.keys(locales).includes(lang)) {
            setLanguage(lang);
        } else {
            setLanguage('_');
        }
    }, []);

    useEffect(() => {
        redirect();
    }, []);

    return (
<div style={{marginTop: '1em'}}>
    <div className="container">
        <h1>{locales[language].title}</h1>
        <p>{locales[language].description}</p>
        <button onClick={() => {
            window.close();
        }}>{locales[language].close}
        </button>
    </div>
</div>
    )
}
